module.exports = ".ResetPassword input{width:100%;margin-top:1rem;padding:0.5rem}.ResetPassword .Alert{margin-top:1rem}.ResetPassword button{margin-top:1rem}\n"